class InstanceStatus {
  static getTranslationByStatus(status) {
    return InstanceStatus.states.get(status + "");
  }

  static getStatus() {
    return InstanceStatus.statesArray;
  }

  static showStart(status) {
    return status === 6;
  }

  static showStop(status) {
    return status === 3;
  }

  static inTransition(status) {
    return (
      status === 0 ||
      status === 2 ||
      status === 4 ||
      status === 5 ||
      status === 7
    );
  }
}

InstanceStatus.statusObject = {
  0: "InstanceStatus.IN_DEPLOYMENT",
  1: "InstanceStatus.DEALLOCATED",
  2: "InstanceStatus.STOPPING",
  3: "InstanceStatus.RUNNING",
  4: "InstanceStatus.STARTING",
  5: "InstanceStatus.STOPPING",
  6: "InstanceStatus.STOPPED",
  7: "InstanceStatus.REMOVING",
  8: "InstanceStatus.RELEASED",
  9: "InstanceStatus.ERROR_CREATING",
  10: "InstanceStatus.ERROR_REMOVING",
  11: "InstanceStatus.PREPARED"
};

InstanceStatus.states = new Map();
InstanceStatus.statesArray = [];
for (const i in InstanceStatus.statusObject) {
  InstanceStatus.statesArray.push({
    code: i,
    translation: InstanceStatus.statusObject[i]
  });
  InstanceStatus.states.set(i + "", InstanceStatus.statusObject[i]);
}

export default InstanceStatus;
